import axios from 'axios';

import baseURL from '../../services/apiBaseUrl';

const publicApi = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' },
});

export async function fetchExamAccess(token) {
  const { data } = await publicApi.get(`/exam-engine/access/${encodeURIComponent(token)}`);
  return data;
}

export async function startExamAttempt(token) {
  const { data } = await publicApi.post(`/exam-engine/access/${encodeURIComponent(token)}/attempt`);
  return data;
}

export async function fetchExamAttempt(token) {
  const { data } = await publicApi.get(`/exam-engine/access/${encodeURIComponent(token)}/attempt`);
  return data;
}

export async function fetchCurrentQuestion(token) {
  const { data } = await publicApi.get(`/exam-engine/access/${encodeURIComponent(token)}/current-question`);
  return data;
}

export async function saveExamAnswer(token, payload) {
  const { data } = await publicApi.post(`/exam-engine/access/${encodeURIComponent(token)}/answers`, payload);
  return data;
}

export async function submitExamAttempt(token) {
  const { data } = await publicApi.post(`/exam-engine/access/${encodeURIComponent(token)}/submit`);
  return data;
}
